var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1357_1710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5131 20.5086C14.3591 26.6823 3.75744 24.3172 0.763082 16.1782C-2.76912 6.57923 6.58333 -2.76805 16.1818 0.762127C24.3352 3.76094 26.6684 14.3343 20.5131 20.5086ZM11.3044 1.79881C3.27491 2.34925 -1.01065 11.6037 3.78923 18.1098C8.20702 24.0992 17.4101 23.4458 20.9912 16.9505C24.9004 9.86025 19.344 1.24837 11.3037 1.79881H11.3044Z",
    fill: "#C03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9551 6.94894C17.2876 7.22924 17.3308 7.79176 17.0663 8.13181L13.229 12.0364L17.1026 15.9218C17.5648 16.7933 16.7911 17.5592 15.9258 17.0984L11.9931 13.2256L8.13349 17.0621C7.3191 17.6049 6.47102 16.8149 6.90078 15.9568L10.803 12.0364L6.96562 8.13181C6.40299 7.28899 7.28985 6.40231 8.13285 6.96483L12.0382 10.8014L15.9595 6.89999C16.2081 6.73537 16.7256 6.75698 16.9538 6.94957L16.9551 6.94894Z",
    fill: "#C03636"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1357_1710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.c2340c1bf5156650fd21dc0901f81074.svg";
export { ForwardRef as ReactComponent };